import { Card, CardContent } from '@mui/material'
import { usePermissions } from 'react-admin'
import { useLocation } from 'react-router-dom'

import { ROLES } from '../constants'

import DashboardAffiliate from './DashboardAffiliate'
import DashboardAdmin from './DashboardAdmin'
import DashboardAffiliateManager from './DashboardAffiliateManager'

const Dashboard = props => {
  const { permissions } = usePermissions()
  const renderContent = () => {
    switch (permissions) {
      case ROLES.PUBLISHER: {
        // return <DashboardPublisher {...props} />
        return (
          <CardContent>
            <div style={{ lineHeight: 1.5 }}>
              Thông Báo Về Việc Nâng cấp Hệ Thống Admin của Fonos
              <br />
              Kính gửi: Quý Anh/Chị Đối Tác
              <br />
              <br />
              Fonos xin thông báo đến các anh/chị hiện hệ thống admin của Fonos
              đang xây dựng và nâng cấp <strong>từ ngày 01/04/2026</strong>.
              Ngày hoạt động trở lại dự kiến: 02/04/2026.
              <br />
              <br />
              Trong thời gian này, việc truy cập hệ thống của Quý Anh/Chị sẽ bị
              tạm dừng cho đến khi hệ thống của Fonos được xây dựng xong.
              <br />
              <br />
              <br />
              Chúng tôi rất xin lỗi về sự bất tiện này và sẽ hoàn tất trong thời
              gian sớm nhất.
              <br />
              Fonos sẽ gửi thông tin đến các anh/chị ngay khi hệ thống admin
              hoạt động trở lại.
              <br />
              <br />
              <strong>
                Trong thời gian này báo cáo Doanh số bán sách và Doanh số hoa
                hồng sẽ được đội ngũ phụ trách gửi cho anh/chị vào email đã đăng
                ký theo lịch định kỳ đã thống nhất.
              </strong>
              <br />
              <br />
              Nếu cần hỗ trợ hoặc có câu hỏi, vui lòng liên hệ tới các SĐT và
              email hỗ trợ sau:
              <br />
              <br />
              Phụ trách đối soát công nợ: thao.nguyen@fonos.vn - 0972 021 289
              <br />
              Phụ trách bản quyền sách: phuongnguyen@fonos.vn - 090 47 42 193
              <br />
              <br />
              Xin chân thành cảm ơn sự thông cảm của Quý NXB và các anh/chị.
              <br />
              <br />
              Trân trọng!
              <br />
            </div>
          </CardContent>
        )
      }
      case ROLES.ADMIN:
      case ROLES.ACCOUNTANT:
      case ROLES.STATISTICAL_STAFF:
      case ROLES.FINANCE_DIRECTOR: {
        return <DashboardAdmin {...props} />
      }

      case ROLES.AFFILIATE:
        return <DashboardAffiliate {...props} />

      case ROLES.AFFILIATE_MANAGER:
        return <DashboardAffiliateManager {...props} />

      default:
        return <CardContent>Welcome back to Fonos</CardContent>
    }
  }
  return <Card>{renderContent()}</Card>
}

export default ({ ...rest }) => {
  const location = useLocation()

  return <Dashboard location={location} {...rest} />
}
